/** The default length is `8`. */
export function generateRandomPassword(length = 8): string {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let retVal = '';

  for (let i = 0; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * charset.length));
  }

  return retVal;
}

/** The default prefix is `dev`, and the default domain is `example.com`. */
export function generateUniqueTestEmail(prefix = 'dev', domain = 'example.com'): string {
  return `${prefix}-${uuidv4()}@${domain}`;
}

/** Creates a unique user ID (UUID version 4). */
function uuidv4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
